import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import DivisionListTable from './DivisionListTable';
const DivisionListPage = () => (_jsx("div", { className: "container-fluid", children: _jsx(DivisionListTable, {}) }));
export default DivisionListPage;
